import { freeze, assign } from 'icepick';
import { ITEMS_ON_PAGE, PAGE } from '../../../common/constants/default-parameters.tsx';
import {
	SET_COMPONENTS_PAGE,
	GET_COMPONENTS_PAGE_REQUEST,
	type SetComponentsPageAction,
	type GetComponentsPageRequestAction,
} from '../../actions.tsx';
import { SET as SET_ERROR, type SetAction } from '../error/actions.tsx';
import type { PageState } from './types.tsx';

export const initialState: PageState = freeze({
	isLoading: false,
	itemsOnPage: ITEMS_ON_PAGE,
	currentPage: PAGE,
});

type Action = GetComponentsPageRequestAction | SetComponentsPageAction | SetAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: PageState = initialState, action: Action): PageState => {
	switch (action.type) {
		case GET_COMPONENTS_PAGE_REQUEST: {
			return assign(state, {
				isLoading: true,
				currentPage: action.payload.page,
			});
		}

		case SET_ERROR: {
			return assign(state, {
				isLoading: false,
			});
		}

		case SET_COMPONENTS_PAGE: {
			return assign(state, {
				isLoading: false,
			});
		}

		default:
			return state;
	}
};
